import { render, staticRenderFns } from "./ColorBand.vue?vue&type=template&id=8559e584"
import script from "./ColorBand.vue?vue&type=script&lang=js"
export * from "./ColorBand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports